import { Button, Dialog, Flex, Text, TextField, IconButton } from '@radix-ui/themes';
import { AiOutlinePlus } from 'react-icons/ai';
import React, { useState } from 'react';
import axiosInstance from '../../config/axiosConfig';
import TableComponent from './TableComponent'; // Adjust path as needed

const AddGatewayPopup = ({ onGatewayAssigned, showToast }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [formData, setFormData] = useState({ igin: '', igvn: '' });
  const [searchResult, setSearchResult] = useState(null);
  const [isSearching, setIsSearching] = useState(false);
  const [isAssigning, setIsAssigning] = useState(false);

  const handleInputChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  const handleSearch = async () => {
    setIsSearching(true);
    try {
      const response = await axiosInstance.post('/gateway/search-gateway', {
        igin: formData.igin,
        igvn: formData.igvn,
      });
      console.log('Search Response:', response.data);
      if (response.data.result) {
        setSearchResult([{
          token: response.data.result.token,
          igin: response.data.result.igin,
          igvn: response.data.result.igvn,
          isActive: response.data.result.isActive ? 'Active' : 'Inactive'
        }]);
      } else {
        setSearchResult({ error: response.data.errorResponse?.message || 'Gateway not found' });
      }
    } catch (error) {
      console.error('Error searching gateway:', error);
      setSearchResult({ error: 'Failed to search gateway' });
    } finally {
      setIsSearching(false);
    }
  };

  const handleAssign = async (gateway) => {
    setIsAssigning(true);
    try {
      const response = await axiosInstance.post('/gateway/assign-gateway', {
        igin: gateway.igin,
        igvn: gateway.igvn,
      });
      if (response.data.result) {
        if (onGatewayAssigned) await onGatewayAssigned();
        if (showToast) showToast('Gateway added successfully');
        setIsOpen(false);
      } else {
        if (showToast) showToast('Failed to assign gateway');
      }
    } catch (error) {
      console.error('Error assigning gateway:', error);
      if (showToast) showToast('Error assigning gateway');
    } finally {
      setIsAssigning(false);
    }
  };

  const tableColumns = [
    { key: 'igin', title: 'IGIN' },
    { key: 'igvn', title: 'IGVN' },
    { key: 'isActive', title: 'Status' },
    {
      key: 'action',
      title: 'Action',
      render: (_, row) => (
        <IconButton
          variant="ghost"
          onClick={() => handleAssign(row)}
          disabled={isAssigning}
        >
          <AiOutlinePlus size={16} />
        </IconButton>
      ),
    },
  ];

  return (
    <Dialog.Root open={isOpen} onOpenChange={setIsOpen}>
      <Dialog.Trigger>
        <Button onClick={() => { setIsOpen(true); setSearchResult(null); setFormData({ igin: '', igvn: '' }); }}>
          Add Gateway
        </Button>
      </Dialog.Trigger>

      <Dialog.Content maxWidth="450px">
        <Dialog.Title>Add Gateway</Dialog.Title>
        <Dialog.Description size="2" mb="4">
          Search for a gateway by IGIN and IGVN.
        </Dialog.Description>

        <Flex direction="column" gap="3">
          <label className='w-[100%]'>
            <Text as="div" size="2" mb="1" weight="bold">IGIN</Text>
            <TextField.Root
              value={formData.igin}
              onChange={(e) => handleInputChange('igin', e.target.value)}
              placeholder="Enter IGIN"
            />
          </label>
          <label className='w-[100%]'>
            <Text as="div" size="2" mb="1" weight="bold">IGVN</Text>
            <TextField.Root
              value={formData.igvn}
              onChange={(e) => handleInputChange('igvn', e.target.value)}
              placeholder="Enter IGVN"
            />
          </label>
        </Flex>

        <Flex gap="3" mt="4" justify="end">
          <Button
            variant="soft"
            color="gray"
            onClick={() => setIsOpen(false)}
            disabled={isSearching || isAssigning}
            type="button"
          >
            Cancel
          </Button>
          <Button
            onClick={handleSearch}
            disabled={isSearching || isAssigning || !formData.igin || !formData.igvn}
            type="button"
          >
            {isSearching ? 'Searching...' : 'Search'}
          </Button>
        </Flex>

        {searchResult && (
          <Flex direction="column" gap="2" mt="4" align="center">
            {Array.isArray(searchResult) ? (
              <>
                <Text size="2" color="green">Gateway found</Text>
                <TableComponent
                  dataStructure={searchResult}
                  columns={tableColumns}
                />
              </>
            ) : (
              <Text size="2" color="tomato">{searchResult.error || 'Try again'}</Text>
            )}
          </Flex>
        )}
      </Dialog.Content>
    </Dialog.Root>
  );
};

export default AddGatewayPopup;